import React from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material';

export type ModalContent = {
	modalTitle?: React.ReactNode;
	modalBody?: React.ReactNode;
	modalFooter?: React.ReactNode;
};

interface ModalProps extends ModalContent {
	open: boolean;
	onClose: () => void;
	minWidth?: string;
}

export const Modal: React.FC<ModalProps> = ({
	open,
	onClose,
	modalTitle,
	modalBody,
	modalFooter,
	minWidth = '400px',
}) => {
	return (
		<StyledDialog
			open={open}
			onClose={onClose}
			slotProps={{
				paper: {
					sx: {
						p: 0,
						minWidth: minWidth,
					},
				},
			}}
		>
			{modalTitle ? (
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="space-between"
					sx={{ px: 3, pt: 3 }}
				>
					<DialogTitle component="div" sx={{ p: 0 }}>
						{modalTitle}
					</DialogTitle>
					<IconButton onClick={onClose} aria-label="close" size="small">
						<CloseIcon />
					</IconButton>
				</Stack>
			) : (
				<Stack direction="row" justifyContent="flex-end" sx={{ px: 3, pt: 3 }}>
					<IconButton onClick={onClose} aria-label="close" size="large">
						<CloseIcon />
					</IconButton>
				</Stack>
			)}
			<DialogContent>{modalBody}</DialogContent>
			{modalFooter && (
				<DialogActions>
					<Stack
						direction="row"
						spacing={2}
						justifyContent="flex-end"
						sx={{ width: '100%' }}
					>
						{modalFooter}
					</Stack>
				</DialogActions>
			)}
		</StyledDialog>
	);
};

const StyledDialog = styled(Dialog)(({ theme }) => ({
	'& .MuiDialogContent-root': {
		padding: theme.spacing(2, 3, 4, 3),
	},
	'& .MuiDialogActions-root': {
		padding: theme.spacing(2, 3),
		borderTop: '1px solid',
		borderColor: theme.palette.divider,
	},
}));
